import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=d1919e2e"
import script from "./checkout.vue?vue&type=script&lang=js"
export * from "./checkout.vue?vue&type=script&lang=js"
import style0 from "./checkout.vue?vue&type=style&index=0&id=d1919e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonIcon: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/Icon/index.vue').default,CartCheckoutViewsDefault: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/cart/checkout/views/Default.vue').default,CartCheckoutContainer: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/cart/checkout/Container.vue').default})
